import React from 'react';

/** Lucide-style line icons for lists (the prototype's Bookmark, Check, Globe, Lock, Plus). */

const Icon = ({
    children,
    className = 'size-4 shrink-0',
}: {
    children: React.ReactNode;
    className?: string;
}) => (
    <svg
        aria-hidden="true"
        focusable="false"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
    >
        {children}
    </svg>
);

export const BookmarkIcon = ({ filled = false }: { filled?: boolean }) => (
    <svg
        aria-hidden="true"
        focusable="false"
        viewBox="0 0 24 24"
        fill={filled ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth={1.75}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="size-4 shrink-0"
    >
        <path d="M19 21l-7-4-7 4V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
    </svg>
);

export const CheckIcon = () => (
    <Icon className="size-3.5 shrink-0">
        <path d="M20 6 9 17l-5-5" />
    </Icon>
);

export const GlobeIcon = () => (
    <Icon className="size-3.5 shrink-0">
        <circle cx="12" cy="12" r="10" />
        <path d="M2 12h20M12 2a15.3 15.3 0 0 1 0 20M12 2a15.3 15.3 0 0 0 0 20" />
    </Icon>
);

export const LockIcon = () => (
    <Icon className="size-3.5 shrink-0">
        <rect x="3" y="11" width="18" height="11" rx="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </Icon>
);

export const PlusIcon = () => (
    <Icon>
        <path d="M12 5v14M5 12h14" />
    </Icon>
);

export const PencilIcon = () => (
    <Icon>
        <path d="M4 20h4L19 9l-4-4L4 16v4ZM13.5 6.5l4 4" />
    </Icon>
);

export const TrashIcon = () => (
    <Icon>
        <path d="M3 6h18M8 6V4h8v2M19 6l-1 14H6L5 6M10 11v6M14 11v6" />
    </Icon>
);
